// src/foundations/breakpoints.ts
var breakpoints = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
};
var breakpoints_default = breakpoints;

export {
  breakpoints_default
};
//# sourceMappingURL=chunk-TXLFBUTF.mjs.map